import type {
  AuthorizedOrderDataIntegrityStatus,
  AuthorizedOrderProcessStatus,
  DateTimeValue,
} from '#/api/authorized-order/model';

type TagType = 'danger' | 'info' | 'primary' | 'success' | 'warning';

export const STATUS_TABS: Array<{
  ignored?: number;
  label: string;
  processStatus?: AuthorizedOrderProcessStatus;
  value: string;
}> = [
  { label: '全部订单', value: '' },
  {
    label: '待生成采购',
    processStatus: 'TO_GENERATE_PURCHASE',
    value: 'TO_GENERATE_PURCHASE',
  },
  {
    label: '等待TikTok开放履约',
    processStatus: 'WAITING_PLATFORM_RELEASE',
    value: 'WAITING_PLATFORM_RELEASE',
  },
  {
    label: '信息待补',
    processStatus: 'INFO_TO_COMPLETE',
    value: 'INFO_TO_COMPLETE',
  },
  {
    label: '已关联采购',
    processStatus: 'LINKED_PURCHASE',
    value: 'LINKED_PURCHASE',
  },
  {
    label: '已关联小包',
    processStatus: 'LINKED_PARCEL',
    value: 'LINKED_PARCEL',
  },
  {
    label: '同步异常',
    processStatus: 'SYNC_EXCEPTION',
    value: 'SYNC_EXCEPTION',
  },
  { label: '已取消', processStatus: 'CANCELED', value: 'CANCELED' },
  { label: '已忽略', ignored: 1, value: 'IGNORED' },
];

export const PLATFORM_OPTIONS = [
  { label: '手工订单', value: 'MANUAL' },
  { label: 'TikTok Shop', value: 'TIKTOK' },
  { label: 'Amazon', value: 'AMAZON' },
  { label: 'Walmart', value: 'WALMART' },
  { label: 'eBay', value: 'EBAY' },
  { label: 'Shopify', value: 'SHOPIFY' },
];

export function dash(value?: null | number | string) {
  return value === undefined || value === null || value === '' ? '-' : value;
}

export function isApiAuthorizedOrder(row?: { platformCode?: string }) {
  return Boolean(row?.platformCode && row.platformCode !== 'MANUAL');
}

export function formatAuthorizedOrderMoney(
  value?: null | number | string,
  currency = 'USD',
  forceNegative = false,
) {
  if (value === undefined || value === null || value === '') return '-';
  const amount = Number(value);
  if (!Number.isFinite(amount)) return '-';
  const negative = forceNegative || amount < 0;
  const prefix = negative ? '- ' : '';
  return `${prefix}${currency || 'USD'} ${Math.abs(amount).toFixed(2)}`;
}

export function formatDateTime(value?: DateTimeValue) {
  if (Array.isArray(value)) {
    const [year, month, day, hour = 0, minute = 0, second = 0] = value;
    if (!year || !month || !day) return '-';
    return `${year}-${pad(month)}-${pad(day)} ${pad(hour)}:${pad(minute)}:${pad(second)}`;
  }
  return dash(value);
}

export function processStatusLabel(value?: AuthorizedOrderProcessStatus) {
  const map: Record<AuthorizedOrderProcessStatus, string> = {
    CANCELED: '已取消',
    INFO_TO_COMPLETE: '信息待补',
    LINKED_PARCEL: '已关联小包',
    LINKED_PURCHASE: '已关联采购',
    SYNC_EXCEPTION: '同步异常',
    TO_GENERATE_PURCHASE: '待生成采购',
    WAITING_PLATFORM_RELEASE: '等待TikTok开放履约',
  };
  return value ? (map[value] ?? value) : '-';
}

export function processStatusTone(
  value?: AuthorizedOrderProcessStatus,
): TagType {
  const map: Record<AuthorizedOrderProcessStatus, TagType> = {
    CANCELED: 'info',
    INFO_TO_COMPLETE: 'warning',
    LINKED_PARCEL: 'success',
    LINKED_PURCHASE: 'primary',
    SYNC_EXCEPTION: 'danger',
    TO_GENERATE_PURCHASE: 'warning',
    WAITING_PLATFORM_RELEASE: 'warning',
  };
  return value ? (map[value] ?? 'info') : 'info';
}

export function integrityLabel(value?: AuthorizedOrderDataIntegrityStatus) {
  const map: Record<AuthorizedOrderDataIntegrityStatus, string> = {
    ADDRESS_PENDING: 'TikTok暂未开放地址',
    ADDRESS_MISSING: '地址缺失',
    COMPLETE: '完整',
    PRODUCT_MISSING: '商品缺失',
    QUANTITY_INVALID: '数量异常',
    SKU_MISSING: 'SKU 缺失',
  };
  return value ? (map[value] ?? value) : '-';
}

export function integrityTone(
  value?: AuthorizedOrderDataIntegrityStatus,
): TagType {
  return value === 'COMPLETE' ? 'success' : 'warning';
}

function pad(value: number) {
  return String(value).padStart(2, '0');
}
